import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PoweredByBomAdmin   from '../bom/components/PoweredByBomAdmin'

export default (props) => {
  const classSection = classnames('bom-file-requirement', { 'd-none': props.showSummary });

  return (
    <div className={classSection}>
      <ul>
        <li>Maximum upload size is 25 mb</li>
        <li>File needs to be in an .xls or .xlsx file format</li>
        <li>If exporting from a non-Microsoft application, the .xls format may work best</li>
        <li>Do not zip your BOM file</li>
        <li>Read our BOM Preparation Tips and Tricks for best results</li>
      </ul>
      <PoweredByBomAdmin />
    </div>
  );
};

    